const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const TOKEN_KEY = 'trace_admin_token';

function getToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

function decodeUserId(token) {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload?.sub || payload?.user_id || payload?.id || null;
  } catch { return null; }
}

function detectTenantSlug() {
  try {
    const qp = new URLSearchParams(window.location.search).get('tenant');
    if (qp) return qp.toLowerCase().trim();
    const host = (window.location.hostname || '').toLowerCase();
    const root = 'damattsystems.com.br';
    if (host && host.endsWith(`.${root}`)) {
      const sub = host.slice(0, host.length - root.length - 1);
      if (sub && !['www', 'admin', 'app', 'api', 'menu'].includes(sub)) return sub;
    }
  } catch { /* ignore */ }
  return null;
}

export function sendError(payload) {
  const token = getToken();
  const userId = decodeUserId(token);
  const tenantId = detectTenantSlug();
  const body = {
    ...payload,
    user_id: payload.user_id || userId,
    tenant_id: payload.tenant_id || tenantId,
    url: payload.url || window.location.href,
    user_agent: payload.user_agent || navigator.userAgent,
  };

  try {
    fetch(`${BACKEND_URL}/api/log-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(() => {});
  } catch { /* ignore */ }
}

let installed = false;
export function installGlobalErrorHandlers() {
  if (installed) return;
  installed = true;

  window.onerror = (message, source, lineno, colno, error) => {
    sendError({
      message: typeof message === 'string' ? message : String(message),
      source: source || '',
      line: lineno || null,
      column: colno || null,
      stack: error?.stack || '',
    });
  };

  window.onunhandledrejection = (event) => {
    const reason = event?.reason;
    sendError({
      message: reason?.message || String(reason) || 'Unhandled promise rejection',
      stack: reason?.stack || '',
      source: 'unhandledrejection',
    });
  };
}
